import Organizations_Users_AccountPage from "@Organizations/Users/Pages/AccountPage.vue";
import Organizations_Users_ChangePasswordPage from "@Organizations/Users/Pages/ChangePasswordPage.vue";
import Organizations_Users_DashboardPage from "@Organizations/Users/Pages/DashboardPage.vue";
import Organizations_Users_StartupPage from "@Organizations/Users/Pages/StartupPage.vue";
import Organizations_Users_RequestResetPasswordPage from "@Organizations/Users/Pages/RequestResetPasswordPage.vue";
import Organizations_Users_SigninPage from "@Organizations/Users/Pages/SigninPage.vue";
import Organizations_Users_SsoPage from "@Organizations/Users/Pages/SsoPage.vue";

import Organizations_Users_Admin_ActiveUsersPage from "@Organizations/Users/Pages/Admin/ActiveUsersPage.vue";
import Organizations_Users_Admin_CreateGlobalAdminPage from "@Organizations/Users/Pages/Admin/CreateGlobalAdminPage.vue";
import Organizations_Users_Admin_CreateOrganizationAdminPage from "@Organizations/Users/Pages/Admin/CreateOrganizationAdminPage.vue";
import Organizations_Users_Admin_CreateUserPage from "@Organizations/Users/Pages/Admin/CreateUserPage.vue";
import Organizations_Users_Admin_DeletedUsersPage from "@Organizations/Users/Pages/Admin/DeletedUsersPage.vue";
import Organizations_Users_Admin_LockedUsersPage from "@Organizations/Users/Pages/Admin/LockedUsersPage.vue";
import Organizations_Users_Admin_ServiceAccountsPage from "@Organizations/Users/Pages/Admin/ServiceAccountsPage.vue";
import Organizations_Users_Admin_LockedServiceAccountsPage from "@Organizations/Users/Pages/Admin/LockedServiceAccountsPage.vue";
import Organizations_Users_Admin_DeletedServiceAccountsPage from "@Organizations/Users/Pages/Admin/DeletedServiceAccountsPage.vue";
import Organizations_Users_Admin_CreateServiceAccountPage from "@Organizations/Users/Pages/Admin/CreateServiceAccountPage.vue";
import Organizations_Users_Admin_ManageUserDetailsPage from "@Organizations/Users/Pages/Admin/ManageUserDetailsPage.vue";
import Organizations_Users_Admin_ManageUserOrganizationPage from "@Organizations/Users/Pages/Admin/ManageUserOrganizationPage.vue";
import Organizations_Users_Admin_ManageUserPage from "@Organizations/Users/Pages/Admin/ManageUserPage.vue";
import Organizations_Users_Admin_ManageUserRolesPage from "@Organizations/Users/Pages/Admin/ManageUserRolesPage.vue";
import Organizations_Users_Admin_ManageUserWorkspacesPage from "@Organizations/Users/Pages/Admin/ManageUserWorkspacesPage.vue";
import Organizations_Users_Admin_UserAccessRequestsPage from "@Organizations/Users/Pages/Admin/UserAccessRequestsPage.vue";
import Organizations_Users_Admin_UserAccessRequestsRejectedPage from "@Organizations/Users/Pages/Admin/UserAccessRequestsRejectedPage.vue";

export const routes = [
    // pages
    {
        path: "/",
        component: Organizations_Users_StartupPage
    },
    {
        path: "/organizations/users/account",
        component: Organizations_Users_AccountPage
    },
    {
        path: "/organizations/users/changepassword",
        component: Organizations_Users_ChangePasswordPage
    },
    {
        path: "/organizations/users/dashboard",
        component: Organizations_Users_DashboardPage
    },
    {
        path: "/organizations/users/requestresetpassword/:email?",
        component: Organizations_Users_RequestResetPasswordPage
    },
    {
        path: "/signin",
        redirect: "/organizations/users/signin"
    },
    {
        path: "/organizations/users/signin",
        component: Organizations_Users_SigninPage
    },
    {
        path: "/organizations/users/sso",
        component: Organizations_Users_SsoPage
    },

    // admin pages
    {
        path: "/admin/organizations/users/active/:tid",
        component: Organizations_Users_Admin_ActiveUsersPage
    },
    {
        path: "/admin/organizations/users/create/:tid",
        component: Organizations_Users_Admin_CreateUserPage
    },
    {
        path: "/admin/organizations/users/createglobaladmin",
        component: Organizations_Users_Admin_CreateGlobalAdminPage
    },
    {
        path: "/admin/organizations/users/createorganizationadmin/:tid",
        component: Organizations_Users_Admin_CreateOrganizationAdminPage
    },
    {
        path: "/admin/organizations/users/deleted/:tid",
        component: Organizations_Users_Admin_DeletedUsersPage
    },
    {
        path: "/admin/organizations/users/locked/:tid",
        component: Organizations_Users_Admin_LockedUsersPage
    },
    {
        path: "/admin/organizations/users/service-accounts/:tid",
        component: Organizations_Users_Admin_ServiceAccountsPage
    },
    {
        path: "/admin/organizations/users/service-accounts/locked/:tid",
        component: Organizations_Users_Admin_LockedServiceAccountsPage
    },
    {
        path: "/admin/organizations/users/service-accounts/deleted/:tid",
        component: Organizations_Users_Admin_DeletedServiceAccountsPage
    },
    {
        path: "/admin/organizations/users/create-service-account/:tid",
        component: Organizations_Users_Admin_CreateServiceAccountPage
    },
    {
        path: "/admin/organizations/users/manage/details/:id",
        component: Organizations_Users_Admin_ManageUserDetailsPage
    },
    {
        path: "/admin/organizations/users/manage/organization/:id?",
        component: Organizations_Users_Admin_ManageUserOrganizationPage
    },
    {
        path: "/admin/organizations/users/manage/roles/:id?",
        component: Organizations_Users_Admin_ManageUserRolesPage
    },
    {
        path: "/admin/organizations/users/manage/workspaces/:id",
        component: Organizations_Users_Admin_ManageUserWorkspacesPage
    },
    {
        path: "/admin/organizations/users/manage/:tid/:id",
        component: Organizations_Users_Admin_ManageUserPage
    },
    {
        path: "/admin/organizations/users/manage/:id",
        component: Organizations_Users_Admin_ManageUserPage
    },
    {
        path: "/admin/organizations/users/requests/:id",
        component: Organizations_Users_Admin_UserAccessRequestsPage
    },
    {
        path: "/admin/organizations/users/rejected/:id",
        component: Organizations_Users_Admin_UserAccessRequestsRejectedPage
    },
    {
        path: "/admin/organizations/users/serviceaccounts",
        component: Organizations_Users_Admin_ServiceAccountsPage
    },
    {
        path: "/admin/organizations/users/createserviceaccount",
        component: Organizations_Users_Admin_CreateServiceAccountPage
    },
]
